/* import __COLOCATED_TEMPLATE__ from './from-elsewhere.hbs'; */
var _dec, _class2, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { getOwner } from '@ember/application';
import { schedule } from '@ember/runloop';
import { Promise } from 'rsvp';
import { inject } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
let _class = (_dec = inject('ember-elsewhere'), _class2 = class _class2 extends Component {
  get name() {
    if (this.args.named) {
      throw new Error(`<FromElsewhere> takes a "@name=" parameter, not "@named="`);
    }
    return this.args.name ?? 'default';
  }

  // We don't yield any content on the very first render pass, because
  // we want to give any concurrent {{to-elsewhere}} components a chance
  // to declare their intentions first. This allows the components
  // inside us to see a meaningful initial value on their initial
  // render.

  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "service", _descriptor, this);
    _initializerDefineProperty(this, "initialized", _descriptor2, this);
    let promise = new Promise(resolve => {
      schedule('afterRender', () => {
        this.initialized = true;
        resolve();
      });
    });
    let fastboot = getOwner(this).lookup('service:fastboot');
    if (fastboot && fastboot.isFastBoot) {
      fastboot.deferRendering(promise);
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "service", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "initialized", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _class2);
export { _class as default };